import React from 'react';
import { Box, Typography, Button, Container, Grid, Paper, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PlayArrow, Star, Security, TrendingUp } from '@mui/icons-material';

const HeroSection = styled(Box)(({ theme }) => ({
  background: '#FFFFFF',
  color: '#000000',
  padding: theme.spacing(15, 0),
  textAlign: 'center',
  borderBottom: '1px solid #E5E5E5',
}));

const FeatureCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  height: '100%',
  background: '#FFFFFF',
  boxShadow: 'none',
  border: '1px solid #E5E5E5',
  borderRadius: 8,
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'translateY(-4px)',
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 4),
  fontSize: '1.1rem',
  borderRadius: 8,
  textTransform: 'none',
  fontWeight: 600,
}));

const LandingPage: React.FC = () => {
  return (
    <Box sx={{ bgcolor: '#FFFFFF' }}>
      <HeroSection>
        <Container maxWidth="md">
          <Typography 
            variant="h1" 
            component="h1" 
            gutterBottom 
            sx={{ 
              fontSize: '4rem',
              fontWeight: 700,
              background: 'linear-gradient(45deg, #00AFF0 30%, #00AFF0 90%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mb: 2
            }}
          >
            OnlyFansz
          </Typography>
          <Typography variant="h4" gutterBottom sx={{ color: '#666666', mb: 4 }}>
            Connect with your favorite creators
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 8 }}>
            <StyledButton variant="contained" color="primary" startIcon={<PlayArrow />}>
              Start Creating
            </StyledButton>
            <StyledButton variant="outlined" color="primary">
              Learn More
            </StyledButton>
          </Stack>
        </Container>
      </HeroSection>

      <Container sx={{ py: 8 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <FeatureCard>
              <Star sx={{ fontSize: 40, color: '#00AFF0', mb: 2 }} />
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                For Creators
              </Typography>
              <Typography sx={{ color: '#666666' }}>
                Share your content and connect with your fans on a platform that puts you first.
              </Typography>
            </FeatureCard>
          </Grid>
          <Grid item xs={12} md={4}>
            <FeatureCard>
              <TrendingUp sx={{ fontSize: 40, color: '#00AFF0', mb: 2 }} />
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                For Fans
              </Typography>
              <Typography sx={{ color: '#666666' }}>
                Support your favorite creators and get exclusive access to their content.
              </Typography>
            </FeatureCard>
          </Grid>
          <Grid item xs={12} md={4}>
            <FeatureCard>
              <Security sx={{ fontSize: 40, color: '#00AFF0', mb: 2 }} />
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                Safe & Secure
              </Typography>
              <Typography sx={{ color: '#666666' }}>
                Your privacy and security are our top priorities. We protect your data and transactions.
              </Typography>
            </FeatureCard>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default LandingPage; 